<template>
  <div class="lg:flex lg:items-center lg:justify-between">
    <div class="min-w-0 flex-1">
      <h2
        class="text-2xl/7 font-bold text-gray-900 sm:truncate sm:text-3xl sm:tracking-tight dark:text-white"
      >
        Create Runner
      </h2>
    </div>
  </div>
</template>

<script setup lang="ts"></script>
